export const CURRENT_USER = "currentUser";
export const DEFAULT_PROFILE_IMG = "https://wallpapercave.com/wp/wp9566480.png"
export const DOWNLOAD_URL = "https://byte-download-service-904635731488.us-central1.run.app/download";
export const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
export const MAX_FILE_SIZE_KB = 512;
export const MAX_COMPRESSED_FILE_SIZE_KB = 1024;
export const EMPTY_STRING = "";
export const ENTER = "Enter";
export const SLASH = "/";
export const EMPTY_ARRAY: string[] = [];
export const BLANK = "_blank";
export const VERIFY_USER_INPUT_PT = `
  Given a user's input, your job is to summarize their selection criteria. Your goal is to have a conversation with the user to get a clear understanding of their selection criteria. When you get a description from the user, determine if the user has confirmed your question. If they have not confirmed your question, then return a summary and ask to confirm.
  ---
  When you are asking to confirm the criteria, return a JSON object with this property:
  - responseToUser: string. This is the response you will send to the user which will most likely be a question or summary but it could also be an appropriate response to the conversation.
  For example, if the user says 'I want people smiling in the photo', then the response to the user would be:
  {"responseToUser": "I see, so if there are people in the photo, you want them to be smiling, right?"}
  ---
  If the user has confirmed your question and replies with something similar to "yes", "ok", "okay", "sure", or "I confirm", then return a JSON object with just this property:
  - confirmed: boolean. Set this to true if the user has confirmed your summary.
`;
export const GET_CRITERIA_PT = (history: string) => `
  Given a list messages between a user and an AI assistant, extract the criteria that the user has confirmed. The criteria is a list of objects where each object has the following properties:
  - summary: A short summary of the criterion.
  - criterion: The criterion paraphrased to specify the photos the user wants to cull.
  Return a list of objects where each object has the 'summary' and 'criterion' properties. For example if the history is as follows:
  Model: What kind of photos are you looking for?
  User: I want photos of people smiling.
  Model: I see, so if there are people in the photo, you want them to be smiling, right?
  User: Yes.
  Then return: [{"summary": "People smiling", "criterion": "If there are people in the photo, they should be smiling."}]
  ---
  Messages:
  ${history}
`;
export const CONFIRMATION_OF_CRITERIA_PT = `
  You are a helpful assistant that confirms the criteria that the user has confirmed. Be concise and to the point. Take your time to understand the user's criteria.
`;

/**
 * Paths
 */
export const HOME_PATH = "/"
export const LOGIN_PATH = "/login"
export const REGISTER_PATH = "/register"
export const NEW_COLLECTION_PATH = "/new-collection"
export const LOGIN_N = "Log in";
export const NEW_COLLECTION_N = "New collection";
export const PHOTO_COLLECTIONS_FOLDER = "photo-collections";
export const CURATED_CAP = "Curated";
export const CURATED = "curated";

/**
 * Statuses
 */
export const ERROR = "error"
export const SUCCESS = "success"

/**
 * Storage
 */
export const BATCH_SIZE = 5;
export const ZIP_FILE_TYPE = "application/zip";
export const MAX_FREE_IMG_SIZE = 1024 * 1024 * 2;

/**
 * Firestore
 */
export const NOT_EQUALS = "!=";
export const EQUALS = "==";
export const NOT_IN = "not-in";
export const UPDATED_AT = "updatedAt";
export const CREATED_AT = "createdAt";
export const DESC = "desc";
export const ASC = "asc";
export const ARRAY_CONTAINS_ANY = 'array-contains-any';
export const ARRAY_CONTAINS = 'array-contains';
export const TRANSFORMATIONS = "transformations";
export const TRANSFORMATION = "transformation";
export const COLLECTION_ID = "collectionId";
export const SUB_COLLECTION_ID = "subCollectionId";
export const PHOTOS = "photos";
export const ACCOUNTS = "accounts";
export const APPROVED = "approved";
export const REJECTED = "rejected";
export const PHOTO_LABELS = "photo_labels";
export const STATE_CHANGED = "state_changed";
export const JOBS = "jobs";
export const DOWNLOAD_JOBS = "download_jobs";
export const DELETE_JOBS = "delete_jobs";
export const CURATING = 'curating';
export const CURATION_COMPLETED = "curationCompleted";
export const SUB_COLLECTIONS = "sub_collections";
export const CATEGORIZATIONS = "categorizations";
export const PHOTO_ID = "photoId";
export const LLM_CHATS = "llm_chats";
export const THREAD_ID = "threadId";
export const ROLE = "role";
export const CONTENT = "content";
export const USER = "user";
export const MODEL = "model";
export const RESPONSE_TO_USER = "responseToUser";
export const CONFIRMED = "confirmed";
export const OWNER_ID = "ownerId";

/**
 * Job
 */
export const PHOTO_COLLECTIONS = "photo_collections";
export const PHOTO_COLLECTION_ID = "photoCollectionId";
export const PROCESSING = "processing";
export const RECORDS_CREATED = "recordsCreated";
export const RATING_COMPLETED = "ratingCompleted";
export const RATING_IN_PROGRESS = "ratingInProgress";
export const CONVERSION_TRIGGERED = "conversionTriggered";
export const CURATION_IN_PROGRESS = "curationInProgress";
export const EMAIL = "email";
export const DOWNLOAD_INITIATED = "downloadInitiated";
export const DELETE_INITIATED = "deleteInitiated";
export const TOTAL_TASKS = 10;
export const FILES_LIMIT_TO_WAIT = 20;
